<section class="relative mb-10 flex w-full items-center justify-center gap-0 px-10 xl:px-20 2xl:gap-12 2xl:px-40">
    <button
        type="button"
        class="text-primary hidden cursor-pointer lg:block"
        (click)="scrollPrev()"
        [attr.aria-label]="'carousel.previous' | transloco"
    >
        <svg-icon
            [svgStyle]="{ width: '32px', height: '32px' }"
            src="assets/icons/Arrow-Left-1.svg"
            aria-hidden="true"
        />
    </button>
    <div #emblaViewport class="overflow-hidden">
        <figure class="flex gap-6 md:gap-12">
            @for (supplier of suppliers(); track supplier.id) {
                <a
                    [href]="supplier | pathFromItem: 'supplier'"
                    class="relative flex-[0_0_50%] cursor-pointer sm:flex-[0_0_35%] md:flex-[0_0_30%] xl:flex-[0_0_25%] 2xl:flex-[0_0_20%]"
                >
                    @if (supplier.logo) {
                        <img
                            [ngSrc]="supplier.logo | getDirectusImage"
                            [alt]="supplier.name"
                            width="100"
                            height="100"
                            class="max-h-25 min-h-25 max-w-41.5 min-w-41.5 object-contain md:max-h-37.5 md:min-h-37.5 md:max-w-62.5 md:min-w-62.5"
                            loading="lazy"
                        />
                    }
                </a>
            }
        </figure>
    </div>
    <button
        type="button"
        class="text-primary hidden cursor-pointer lg:block"
        (click)="scrollNext()"
        [attr.aria-label]="'carousel.next' | transloco"
    >
        <svg-icon
            [svgStyle]="{ width: '32px', height: '32px' }"
            src="assets/icons/Arrow-Right-1.svg"
            aria-hidden="true"
        />
    </button>
</section>
